class youkuVideoHandler {
    constructor(obj_id, orbit_instance = null) {
        this.clientId = "4fa8c817b479c1e2";
        this.objId = obj_id;
        this.orbitInstance = orbit_instance;
        this.$root = $(`#${obj_id}`);
        this.instanceId = this.objId.split("youkuplayer-")[1];
        this.videoId = this.$root.attr("videoId");
        this.$thumbnail = this.$root.find(".single-youku-video__thumbnail");
        this.$modal = null;
        this.player = null;
        this.tempScrollTop = 0;
    }

    setup() {
        const apiUrl = `https://api.youku.com/videos/show.json?client_id=${this.clientId}&video_id=${this.videoId}`;
        fetch(apiUrl)
            .then((response) => response.json())
            .then((data) => {
                if (data) {
                    this._initThumbnail(data.bigThumbnail);
                    this.videoData = data;
                    this.$root.find(".single-youku-video__item").attr("data-url", apiUrl);
                    this.$root.find(".single-youku-video__item").attr("data-title", data.title);
                    this.$root.find(".single-youku-video__item").attr("data-video-id", this.videoId);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    _initThumbnail(thumbnail) {
        if (thumbnail) {
            this.$thumbnail.attr("src", thumbnail);
            this.$thumbnail.on("load", () => {
                this.$root.find(".single-youku-video__loader").remove();
                this.$root.find(".single-youku-video__item--error").remove();
                this.$root.find(".single-youku-video__item").show();
            });
            this.$root.find(".single-youku-video__item").on("click", () => {
                this._showPlayer();
            });
        } else {
            console.error("Thumbnail not found");
            this.$root.find(".single-youku-video__loader").hide();
            this.$root.find(".single-youku-video__item--error").show();
            this.$root.find(".single-youku-video__item--error").on("click", () => {
                this.$root.find(".single-youku-video__loader").show();
                this.$root.find(".single-youku-video__item--error").hide();
                this.setup();
            });
        }
    }

    _showPlayer() {
        this.$root.find(".single-youku-video__item").hide();
        this.player = new YKU.Player(`youkuplayer-${this.instanceId}`, {
            styleid: "0",
            client_id: this.clientId,
            vid: this.videoId,
            newPlayer: true,
            autoplay: true,
            events: {
                onPlayerReady: () => {
                    this._resizeMediaBlockYouku();
                    window.addEventListener("resize", () => {
                        this._resizeMediaBlockYouku();
                    });
                },
            },
        });

        return this.player;
    }
}

// Export the class for use in other modules
export { youkuVideoHandler };

document.addEventListener("DOMContentLoaded", function () {
    $(".youku-player").each((index, youkuItem) => {
        const $youkuItem = $(youkuItem);
        const youkuObj = new youkuVideoHandler($youkuItem.attr("id"));
        youkuObj.setup();
    });
});
